/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { success, error } from '@/libs/notification';
import router from '@/router';
import {
  CompaniesState,
  CompaniesDataState,
  CompanyReplaceData,
  CompaniesSubmitData
} from '@/types/master/company';

import { ElLoading } from 'element-plus';
import { handleAuthorizationError } from '@/libs/apiErrorHandler';
import { getAccessToken } from '@/libs/firebaseAuth';
import { getBaseUrl } from '@/libs/env';

export default {
  namespaced: true,
  state: {
    listData: [],
    replaceData: null
  },
  mutations: {
    setCompanies(state: CompaniesState, payload: CompaniesDataState[]) {
      state.listData = payload;
    },
    setReplace(state: CompaniesState, payload: CompanyReplaceData) {
      state.replaceData = payload;
    }
  },
  actions: {
    async fetch(context: any) {
      await axios
        .get(getBaseUrl() + '/master/companies', {
          headers: { auth: await getAccessToken() }
        })
        .then((response) => {
          context.commit('setCompanies', response.data);
          const replaceData: CompanyReplaceData = {};
          response.data.forEach((company: CompaniesDataState) => {
            replaceData[company.id] = {
              name: company.name,
              isAdvanceOrder: company.isAdvanceOrder
            };
          });
          context.commit('setReplace', replaceData);
        })
        .catch(async (e) => {
          if (e.response.status === 401) {
            await handleAuthorizationError();
          } else if (e.response.status < 500) {
            error(e.response.status);
            router.push('/top');
          } else {
            router.push('/error/server');
          }
        });
    },
    async submit(context: any, payload: CompaniesSubmitData) {
      const loadingInstance = ElLoading.service({ fullscreen: true });
      await axios
        .post(getBaseUrl() + '/master/companies', payload, {
          headers: { auth: await getAccessToken() }
        })
        .then(() => {
          success('Success', '販売店企業登録に成功しました。');
          router.push('/master/company');
        })
        .catch(async (e) => {
          loadingInstance.close();
          if (e.response.status === 401) {
            await handleAuthorizationError();
          } else if (e.response.status < 500) {
            error(e.response.status);
          } else {
            router.push('/error/server');
          }
        });
    }
  }
};
